/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Rounds_Locked_HintInputs */



/**
* | output |
* | --- |
* | "Can't change once the tournament has started or is registered with VEKN." |
*
* @param {Tfield_Rounds_Locked_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_rounds_locked_hint = /** @type {((inputs?: Tfield_Rounds_Locked_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Rounds_Locked_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non modifiable une fois le tournoi commencé ou enregistré auprès de la VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede cambiar una vez empezado el torneo o registrado en la VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não pode mudar depois que o torneio começou ou foi registrado na VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non modificabile dopo l'inizio del torneo o la registrazione presso la VEKN.")
	return /** @type {LocalizedString} */ ("Can't change once the tournament has started or is registered with VEKN.")
});